import { Grid } from '@mui/material';

import CountWithTextCard from '../../countWithTextCard';

import IApplicationInsights from './types/IApplicationInsights';

const ApplicationMetrics = ({ agg }: { agg: IApplicationInsights }) => {
  return (
    <Grid container>
      <Grid item xs={4}>
        <CountWithTextCard count={agg.metaData.total} text={''} />
      </Grid>
      <Grid item xs={4}>
        <CountWithTextCard count={agg.metaData.acted} text={'Acted On'} />
      </Grid>
      <Grid item xs={4}>
        <CountWithTextCard count={agg.metaData.viewed} text={'Viewed'} />
      </Grid>
    </Grid>
  );
};

export default ApplicationMetrics;
